import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import VerticalAlignBottomOutlinedSvg from "@ant-design/icons-svg/es/asn/VerticalAlignBottomOutlined";
import AntdIcon from "../components/AntdIcon";
var VerticalAlignBottomOutlined = function VerticalAlignBottomOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: VerticalAlignBottomOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  VerticalAlignBottomOutlined.displayName = 'VerticalAlignBottomOutlined';
}
export default /*#__PURE__*/React.forwardRef(VerticalAlignBottomOutlined);